module.exports = __webpack_public_path__ + "static/media/QD.6940967d.png";